import '../../../../assets/css/screens/customer/dashboard/appservices/WorkerProfile.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import { useBookingContext } from '../../../../context/bookingcontext/BookingContext';
import { useWorkerProfileContext } from '../../../../context/workerprofilecontext/WorkerProfileContext';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Heart, Star, Briefcase, MapPin,
  Clock, Info, MessageCircle, CheckCircle
} from 'lucide-react';

const REVIEWS_MAP = {
  1: [
    { name:'James R.',   time:'2 days ago',   rating:5, text:'Excellent work! Very professional and on time.' },
    { name:'Lisa M.',    time:'1 week ago',   rating:4, text:'Good quality service. Would recommend to others.' },
    { name:'Robert K.',  time:'2 weeks ago',  rating:5, text:'Best in the business. Cleaned everything spotless.' },
  ],
  2: [
    { name:'Sara A.',    time:'3 days ago',   rating:5, text:'Very skilled and polite. Did the job perfectly.' },
    { name:'Kamran B.',  time:'5 days ago',   rating:4, text:'Good work, completed on time. Will hire again.' },
    { name:'Nadia T.',   time:'1 week ago',   rating:5, text:'Amazing service, highly recommended!' },
  ],
  3: [
    { name:'Usman K.',   time:'1 day ago',    rating:5, text:'Outstanding professional. Very thorough job.' },
    { name:'Hina F.',    time:'4 days ago',   rating:5, text:'Exceptional quality and great attitude.' },
    { name:'Ahmer Z.',   time:'2 weeks ago',  rating:4, text:'Reliable and honest. Would hire again.' },
  ],
  4: [
    { name:'Tariq M.',   time:'2 days ago',   rating:4, text:'Decent work, reasonable price.' },
    { name:'Faiza N.',   time:'1 week ago',   rating:4, text:'Got the job done. Satisfied overall.' },
    { name:'Asad R.',    time:'3 weeks ago',  rating:3, text:'Work was okay, could be more careful.' },
  ],
  5: [
    { name:'Bilal Q.',   time:'1 day ago',    rating:5, text:'Top notch! Best professional I have hired.' },
    { name:'Mehwish S.', time:'3 days ago',   rating:5, text:'Very fast and efficient. 10/10 would recommend.' },
    { name:'Danish A.',  time:'1 week ago',   rating:5, text:'Absolutely fantastic work. Very impressed.' },
  ],
  6: [
    { name:'Rabia J.',   time:'2 days ago',   rating:5, text:'Great service, very punctual and clean.' },
    { name:'Zara K.',    time:'6 days ago',   rating:4, text:'Good work, friendly attitude.' },
    { name:'Irfan B.',   time:'2 weeks ago',  rating:5, text:'Did an excellent job, highly satisfied.' },
  ],
};

const DEFAULT_REVIEWS = [
  { name:'Ahmed S.',  time:'3 days ago',  rating:5, text:'Great service! Very professional.' },
  { name:'Maria K.',  time:'1 week ago',  rating:4, text:'Good work, would recommend.' },
  { name:'Zaid M.',   time:'2 weeks ago', rating:5, text:'Excellent! Completed on time.' },
];

const Stars = ({ rating }) => (
  <div className="wd-stars">
    {[1,2,3,4,5].map(s => (
      <Star key={s} size={14}
        fill={s <= rating ? '#f59e0b' : '#e5e7eb'}
        color={s <= rating ? '#f59e0b' : '#e5e7eb'} />
    ))}
  </div>
);

const WorkerDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [liked, setLiked] = useState(false);

  const { worker, categoryName } = location.state || {};

  const w = worker || {
    id: 1, name: 'Ahmed Khan', title: '5 years experience',
    rating: 4.8, reviews: 124, jobs: 230, price: 35, verified: true,
    avatar: 'https://ui-avatars.com/api/?name=Ahmed+Khan&background=0491e1&color=fff&size=200',
  };

  const reviews = REVIEWS_MAP[w.id] || DEFAULT_REVIEWS;

  const specialty = categoryName
    ? categoryName.replace(' Services','').replace(' Service','') + ' Specialist'
    : w.title;

  const handleBook = () => navigate('/book-service', { state: { worker: w, categoryName } });
  const handleChat = () => navigate('/chat', { state: { worker: w } });

  return (
    <>
      <AppNavbar/>
      <div className="wd-page">

        {/* Mobile header */}
        <div className="wd-header">
          <button className="wd-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={22}/>
          </button>
          <h2 className="wd-header-title">Worker Profile</h2>
        </div>

        <div className="wd-body">

          {/* Profile Card */}
          <div className="wd-profile-card">

            {/* Desktop back arrow — top left of card (hidden on mobile via CSS) */}
            <button className="wd-back-desk" onClick={() => navigate(-1)}>
              <ArrowLeft size={22}/>
            </button>

            {/* Heart — top right (handled by CSS positioning) */}
            {/* <button className={`wd-heart ${liked ? 'wd-heart--active' : ''}`} onClick={() => setLiked(p => !p)}>
              <Heart size={20} fill={liked ? '#ef4444' : 'none'} color={liked ? '#ef4444' : '#94a3b8'}/>
            </button> */}

            <div className="wd-avatar-wrap">
              <img src={w.avatar} alt={w.name} className="wd-avatar"/>
            </div>

            <div className="wd-name-row">
              <h4 className="wd-name">{w.name}</h4>
              {w.verified && <CheckCircle size={18} className="wd-check"/>}
            </div>

            <p className="wd-specialty">{specialty}</p>

            <div className="wd-rating-row">
              <Star size={15} fill="#f59e0b" color="#f59e0b"/>
              <span className="wd-rating">{w.rating}</span>
              <span className="wd-rating-count">({w.reviews} reviews)</span>
            </div>

            <div className="wd-stats">
              <div className="wd-stat">
                <span className="wd-stat-val">{w.jobs}</span>
                <span className="wd-stat-lbl">Jobs Done</span>
              </div>
              <div className="wd-stat-divider"/>
              <div className="wd-stat">
                <span className="wd-stat-val">{w.title.replace(' experience','').replace(' years','').replace(' year','') + (w.title.includes('year') ? ' years' : '')}</span>
                <span className="wd-stat-lbl">Experience</span>
              </div>
              <div className="wd-stat-divider"/>
              <div className="wd-stat">
                <span className="wd-stat-val wd-stat-val--price">${w.price}/hr</span>
                <span className="wd-stat-lbl">Rate</span>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="wd-info-list">
            <div className="wd-info-card">
              <div className="wd-info-icon"><MapPin size={17}/></div>
              <div className="wd-info-text">
                <span className="wd-info-label">Location</span>
                <span className="wd-info-value">Lahore, USA</span>
              </div>
            </div>
            <div className="wd-info-card">
              <div className="wd-info-icon"><Clock size={17}/></div>
              <div className="wd-info-text">
                <span className="wd-info-label">Availability</span>
                <span className="wd-info-value">Mon – Sat, 8:00 AM – 6:00 PM</span>
              </div>
            </div>
            <div className="wd-info-card">
              <div className="wd-info-icon"><Info size={17}/></div>
              <div className="wd-info-text">
                <span className="wd-info-label">About</span>
                <span className="wd-info-value">
                  Professional {specialty.toLowerCase()} with {w.title}. Committed to quality and customer satisfaction.
                </span>
              </div>
            </div>
          </div>

          {/* Reviews */}
          <div className="wd-reviews-section">
            <h5 className="wd-reviews-title">Reviews</h5>
            <div className="wd-reviews-list">
              {reviews.map((r, i) => (
                <div key={i} className="wd-review-card">
                  <div className="wd-review-top">
                    <span className="wd-review-name">{r.name}</span>
                    <span className="wd-review-time">{r.time}</span>
                  </div>
                  <Stars rating={r.rating}/>
                  <p className="wd-review-text">{r.text}</p>
                </div>
              ))}
            </div>
          </div>
           {/* Bottom Action Bar */}
        {/* <div className="wd-bottom-bar">
          <button className="wd-chat-btn" onClick={handleChat}>
            <MessageCircle size={18}/> Chat
          </button>
          <button className="wd-book-btn" onClick={handleBook}>
            Book Now – ${w.price}/hr
          </button>
        </div> */}


          <div style={{ height: 20 }}/>
        </div>

       
      </div>
    </>
  );
};

export default WorkerDetail;